import React from 'react'
import PropTypes from 'prop-types'
import { useVariables } from '../../../../providers/VariableProvider'

function Show ({
  applyTo,
  expectedValue,
  defaultValue,
  children
}) {
  const { getVariable } = useVariables()

  const variableValue = getVariable(applyTo, defaultValue)
  if (variableValue !== expectedValue) {
    return null
  }

  return (
    <>
      {children}
    </>
  )
}

Show.propTypes = {
  applyTo: PropTypes.string,
  expectedValue: PropTypes.any,
  defaultValue: PropTypes.any,
  children: PropTypes.any
}

Show.defaultProps = {
  defaultValue: ''
}

export default Show
